// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3580":"b6facc724a6cf7f7","5807":"b817cfe2d69058eb"}[chunkId] + ".js";
};